import { useState } from 'react'

import { SegmentedTabs } from '@/components/ds'
import { DocumentSequences } from '@/containers/Settings/DocumentSequences/DocumentSequences'
import { SettingsPage } from '@/containers/Settings/SettingsLayout'
import { DocumentType } from '@/types/DocumentType'

const types: { value: DocumentType; label: string }[] = [
  { value: 'invoice', label: 'Faktury' },
  { value: 'order', label: 'Výzvy k platbě' },
  { value: 'expense', label: 'Náklady' },
]

export default function SettingsDocumentSequencesPage() {
  const [type, setType] = useState<DocumentType>('invoice')

  return (
    <SettingsPage
      title="Číselné řady"
      description="Jak se číslují nové doklady. Změna se projeví až u dalšího vystaveného dokladu."
      breadcrumbHref="/settings/document-sequences"
    >
      <SegmentedTabs<DocumentType> className="mb-6" value={type} onChange={setType} options={types} />

      <DocumentSequences key={type} type={type} />
    </SettingsPage>
  )
}
